import React, { useState, useEffect } from 'react';
import './RegenerateWorkoutModal.css';

const RegenerateWorkoutModal = ({ workoutId, backendService, close, onSelect = () => {} }) => {
  const [userInput, setUserInput] = useState('');

  useEffect(() => {
    const fetchActivityGenerationInstructions = async () => {
      try {
        const generationInstructions = await backendService.fetchActivityGenerationInstructions(workoutId);
        setUserInput(generationInstructions);
      } catch (error) {
        console.error('Error fetching generation instructions:', error);
      }
    };

    fetchActivityGenerationInstructions();
  }, [workoutId, backendService]);

  const handleInputChange = (event) => {
    setUserInput(event.target.value);
  };

  const handleRegenerateClick = () => {
    onSelect(userInput);
    close();
  };

  return (
    <div className="modal-content">
      <h2>Regenerate Workout</h2>
      <textarea
        value={userInput}
        onChange={handleInputChange}
        placeholder="Enter your preferences for the workout..."
        rows="5"
      />
      <div className="button-container">
        <button className="btn-add" onClick={handleRegenerateClick}>Regenerate</button>
        <button className="btn-cancel" onClick={close}>Cancel</button>
      </div>
    </div>
  );
};

export default RegenerateWorkoutModal;
